import { Typography } from "@mui/material";
import { LoyaltyApi } from "@smartrr/shared/interfaces/loyalty/api";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";
import { LoyaltyStoreAccess } from "../../store";
import { RedeemButton } from "../RedeemButton";
import { SubscriberOnlyBadge } from "../SubscriberOnlyBadge";
import { RewardCostBadge } from "../RewardCostBadge";
import { IncentiveColoredImage } from "../IncentiveColoredImage";
import { prefixClassName } from "@smartrr/shared/components/primitives";

export const IncentiveCard = ({ incentive }: { incentive: LoyaltyApi.Incentive.Type }) => {
  const isOtpEnabled = LoyaltyStoreAccess.useIsOtpEnabled();
  const { symbol: currencySymbol } = LoyaltyStoreAccess.useCurrency();
  const showSubscriberOnlyBadge = incentive.subscriberOnly && isOtpEnabled;
  return (
    <React.Fragment>
      <RewardCostBadge costInPoints={incentive.costInPoints} rewardItemId={incentive.id} />
      <IncentiveColoredImage incentive={incentive} />
      <RedeemButton item={incentive} />
      {showSubscriberOnlyBadge ? <SubscriberOnlyBadge /> : <React.Fragment />}
      <Typography variant="body1" className={prefixClassName("loyalty-rewards-incentive-discount")}>
        {incentive.priceRule.type === "fixed_amount"
          ? typedLocalize("loyalty.xUnitsOffYourNextOrder", {
              amount: -incentive.priceRule.value,
              unitName: currencySymbol,
            })
          : typedLocalize("loyalty.xPercentOffYourNextOrder", { amount: -incentive.priceRule.value })}
      </Typography>
    </React.Fragment>
  );
};
